import { AppStoreBase } from './AppStoreBase';
import { IAppComponents } from '../models/IAppComponents';
import { computed } from 'mobx';
import { StoreContext } from '../../../configuration/StoreContext';
import { ICardProps } from '@kurtosys/ksys-app-components/dist/components/base/Card/models';
import { ISummaryBlocksProps } from '@kurtosys/ksys-app-components/dist/components/fact/SummaryBlocks/models';
import { Manifest } from '../../../configuration/Manifest';
import { ISummaryBlockProps } from '@kurtosys/ksys-app-components/dist/components/fact/SummaryBlock/models/ISummaryBlockProps';
import { utils } from '@kurtosys/ksys-app-template';

/* [Component: appStoreComponentImport] */

export class AppStore extends AppStoreBase {
	constructor(element: HTMLElement, url: string, storeContext: StoreContext, manifest: Manifest) {
		super(element, url, storeContext, manifest);
	}

	@computed
	get hasData(): boolean {
		const valid = this.summaryBlocksProps && Array.isArray(this.summaryBlocksProps.blocks) && this.summaryBlocksProps.blocks.reduce((hasValues: boolean, block: ISummaryBlockProps) => {
			let blockValue;
			if (block && block.riskRatingProps) {
				blockValue = block.riskRatingProps.value;
			}
			else if (block && block.morningstarRatingProps) {
				blockValue = block.morningstarRatingProps.morningStarRating;
			}
			else {
				blockValue = block.value;
			}
			if (!utils.typeChecks.isNullOrUndefined(blockValue)) {
				hasValues = true;
			}
			return hasValues;
		}, false);
		return valid === true;
	}

	@computed
	get components(): IAppComponents {
		return {
			/* [Component: appStoreComponent] */
		};
	}

	@computed
	get cardProps(): ICardProps | undefined {
		const cardProps = this.appComponentConfiguration && this.appComponentConfiguration.cardProps;
		return this.mergeQueriesAndProps(cardProps);
	}

	@computed
	get summaryBlocksProps(): ISummaryBlocksProps | undefined {
		const summaryBlocks = this.appComponentConfiguration && this.appComponentConfiguration.summaryBlocks;
		return this.mergeQueriesAndProps(summaryBlocks);
	}

}